/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 13/11/2023
 */

import React, { useContext, useState } from 'react'
import styles from "./DetailsStep.module.css"
import { Button, IconButton, Typography } from '@mui/material'
import Counter from '../Shared/counter'
import CheckoutContext from '../../Context/CheckoutContext'
import { SET_SUB_CATEGORY, SET_TOTAL } from '../../Pages/CheckoutPage'
import { Delete } from '@mui/icons-material'

const SubCategoryCard = ({ cat }) => {

    const { checkoutData, dispatch } = useContext(CheckoutContext);
    const [qty, setQty] = useState(0);

    const onSelectCategory = (cat) => {
        dispatch({ type: SET_SUB_CATEGORY, payload: {
            catId: cat.catId,
            subCatName: cat.catDisplay
        }})
        dispatch({ type: SET_TOTAL, payload: cat.price})
        setQty(1)
    }

    const onDeleteClick = () => {
        dispatch({ type: SET_SUB_CATEGORY, payload: null})
        setQty(prev => prev - 1)
    }

    return (
        <div className={checkoutData.catId == cat.catId ? styles.itemContainerSelected : styles.itemContainer}>
            <img src={`${process.env.REACT_APP_IMAGE_URL}${cat.imageList?.split(",")[0]}`} alt={cat.title} className={styles.itemImage} loading='lazy' />
            <div>
                <Typography className={styles.subTitle}>{cat.catDisplay}</Typography>
                <Typography className={styles.itemDescription}>{cat.catDesc}</Typography>
                <Typography className={styles.itemPrice}>
                {cat.price !== cat.priceWithOff ? (
                <>
                  <span
                    className={styles.itemPrice}
                    style={{ textDecoration: 'line-through', color: '#a90000' }}
                  >
                    {process.env.REACT_APP_CURRENCY} {cat.price}
                  </span>
                  <span> </span>
                </>
              ) : null}                    
              {process.env.REACT_APP_CURRENCY} {cat.priceWithOff}
                </Typography>
            </div>
            {checkoutData.catId == cat.catId ?
            // <Counter
            //     className={styles.counter}
            //     disableIncrement={true}
            //     onIncrement={handleQtyIncrement}
            //     onDecrement={onDeleteClick}
            //     value={1}
            // />
            // <IconButton onClick={onDeleteClick} className={styles.counter}><Delete/></IconButton>
            null
            :
            <Button variant='contained' className={styles.addButton} onClick={() => onSelectCategory(cat)}>Add +</Button>}
        </div>
    )
}

export default SubCategoryCard